import { Actions, ActionTypes } from './actions';
import { adapter, initialState, SelfDiagnosisState } from './state';

export function reducer(state = initialState, action: Actions): SelfDiagnosisState {
  switch (action.type) {
    case ActionTypes.FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    case ActionTypes.GET_ALL_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.GET_ALL_SUCCESS:
      return adapter.setAll(action.entities, {
        ...state,
        isLoading: false,
        error: null,
        selected: null,
      });

    case ActionTypes.GET_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.GET_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        selected: { ...action.entity },
      };

    case ActionTypes.UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.UPDATE_SUCCESS:
      return adapter.upsertOne(action.entity, {
        ...state,
        isLoading: false,
        error: null,
        selected: null,
      });

    case ActionTypes.DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.DELETE_SUCCESS:
      return adapter.removeOne(action.entity.id, {
        ...state,
        isLoading: false,
        error: null,
        selected: null,
      });

    case ActionTypes.UPLOAD_ICON_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.DELETE_ICON_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case ActionTypes.SET_SELECTED:
      return {
        ...state,
        isLoading: false,
        error: null,
        selected: action.entity ? { ...action.entity } : null,
      };

    default:
      return state;
  }
}
